module.exports = __webpack_public_path__ + "img/partner5.9c589719.png";